<template>
  <page>
    <div id="up" class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title ">{{$t('My account')}}</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content">
        <div class="m-portlet m-portlet--full-height  ">
          <div class="tab-content">
            <div class="">
              <div class="m-form m-form--fit m-form--label-align-right">
                <div class="m-portlet__body mb-0 pb-0">
                  <div class="form-group m-form__group m--margin-top-10 m--hide">
                  </div>
                  <div v-if="isBaseFieldEnabled('email')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="email" class="form-label">
                        {{$t('Email')}}&nbsp;<span v-if="isRequiredField('email')">*</span>
                      </label>
                      <input id="email" class="form-control m-input" type="text" :value="user.email" disabled>
                      <b-form-text  v-if="isProfileEditEnabled" class="mt-2 text-muted text-justify">
                        {{$t('If change email, use procedure')}}
                        <router-link :to="{name: 'ChangeEmail'}">{{$t('Here')}}</router-link>.
                      </b-form-text >
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('email')">
                        {{ fieldsDescription.email }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('name')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="name" class="form-label" :class="labelClass('name')">
                        {{$t('Name')}}&nbsp;<span v-if="isRequiredField('name')">*</span>
                      </label>
                      <b-form-input id="name"
                                    type="text"
                                    maxlength="30"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('name')"
                                    v-model="user.name"></b-form-input>
                      <b-form-text v-if="errors.name" class="text-danger">
                        {{ errors.name }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('name')">
                        {{ fieldsDescription.name }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('surname')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="surname" class="form-label" :class="labelClass('surname')">
                        {{$t('Surname')}}&nbsp;<span v-if="isRequiredField('surname')">*</span>
                      </label>
                      <b-form-input id="surname"
                                    maxlength="30"
                                    type="text"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('surname')"
                                    v-model="user.surname"></b-form-input>
                      <b-form-text v-if="errors.surname" class="text-danger">
                        {{ errors.surname }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('surname')">
                        {{ fieldsDescription.surname }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('address')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="address" class="form-label" :class="labelClass('address')">
                        {{$t('Address')}}&nbsp;<span v-if="isRequiredField('address')">*</span>
                      </label>
                      <b-form-input id="address"
                                    maxlength="50"
                                    type="text"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('address')"
                                    v-model="user.address"></b-form-input>
                      <b-form-text v-if="errors.address" class="text-danger">
                        {{ errors.address }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('address')">
                        {{ fieldsDescription.address }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('city')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="city" class="form-label" :class="labelClass('city')">
                        {{$t('City')}}&nbsp;<span v-if="isRequiredField('city')">*</span>
                      </label>
                      <b-form-input id="city"
                                    type="text"
                                    maxlength="30"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('city')"
                                    v-model="user.city"></b-form-input>
                      <b-form-text v-if="errors.city" class="text-danger">
                        {{ errors.city }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('city')">
                        {{ fieldsDescription.city }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('postcode')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="post-code" class="form-label"  :class="labelClass('postcode')">
                        {{$t('Postal Code')}}&nbsp;<span v-if="isRequiredField('postcode')">*</span>
                      </label>
                      <b-form-input id="post-code"
                                    type="text"
                                    maxlength="6"
                                    inputmode="numeric"
                                    :placeholder="$t('np: 00-000')"
                                    :formatter="formatPostcode"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('postcode')"
                                    v-model="user.postcode"></b-form-input>
                      <b-form-text v-if="errors.postcode" class="text-danger">
                        {{ errors.postcode }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('postcode')">
                        {{ fieldsDescription.postcode }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('voivodeship')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="voivodeship" class="form-label" :class="labelClass('voivodeship')">
                        {{$t('State/Region')}}&nbsp;<span v-if="isRequiredField('voivodeship')">*</span>
                      </label>
                      <b-form-select id="voivodeship"
                                     :options="voivodeships"
                                     :disabled="!isProfileEditEnabled"
                                     :required="isRequiredField('voivodeship')"
                                     v-model="user.voivodeship"></b-form-select>
                      <b-form-text v-if="errors.voivodeship" class="text-danger">
                        {{ errors.voivodeship }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('voivodeship')">
                        {{ fieldsDescription.voivodeship }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('birthday')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="date" class="form-label" :class="labelClass('birthday')">
                        {{$t('Date of Birth')}}&nbsp;<span v-if="isRequiredField('birthday')">*</span>
                      </label>
                      <div class="input-group date">
                        <date-picker :lang="calendarLocale"
                                     :format="calendarFormat"
                                     :clearable="true"
                                     :not-after="new Date()"
                                     :disabled="!isProfileEditEnabled"
                                     v-model="user.birthday"
                                     input-class="form-control"
                                     :input-attr="{required: isRequiredField('birthday')}">
                          <template slot="calendar-icon">&nbsp;</template>
                        </date-picker>
                        <div class="input-group-append d-none d-lg-flex">
                          <span class="input-group-text">
                             <i class="la la-calendar-check-o"></i>
                          </span>
                        </div>
                      </div>
                      <b-form-text v-if="errors.birthday" class="text-danger">
                        {{ errors.birthday }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('birthday')">
                        {{ fieldsDescription.birthday }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('sex')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="sex" class="form-label" :class="labelClass('sex')">
                        {{$t('Gender')}}&nbsp;<span v-if="isRequiredField('sex')">*</span>
                      </label>
                      <b-form-select id="sex"
                                     v-model="user.sex"
                                     :disabled="!isProfileEditEnabled"
                                     :options="[
                                       {
                                         value: '',
                                         text: $t('Choose')
                                       },
                                       {
                                         value: 'F',
                                         text: $t('Woman')
                                       },
                                       {
                                         value: 'M',
                                         text: $t('Man')
                                       }
                                     ]"
                      ></b-form-select>
                      <b-form-text v-if="errors.sex" class="text-danger">
                        {{ errors.sex }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('sex')">
                        {{ fieldsDescription.sex }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('company')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="company" class="form-label" :class="labelClass('company')">
                        {{$t('Company')}}&nbsp;<span v-if="isRequiredField('company')">*</span>
                      </label>
                      <b-form-input id="company"
                                    type="text"
                                    maxlength="300"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('company')"
                                    v-model="user.company"></b-form-input>
                      <b-form-text v-if="errors.company" class="text-danger">
                        {{ errors.company }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('company')">
                        {{ fieldsDescription.company }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('nip')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="nip" class="form-label" :class="labelClass('nip')">
                        {{$t('Tax identification')}}&nbsp;<span v-if="isRequiredField('nip')">*</span>
                      </label>
                      <b-form-input id="nip"
                                    type="text"
                                    maxlength="20"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('nip')"
                                    v-model="user.nip"></b-form-input>
                      <b-form-text v-if="errors.nip" class="text-danger">
                        {{ errors.nip }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('nip')">
                        {{ fieldsDescription.nip }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('phone')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="phone" class="form-label" :class="labelClass('phone')">
                        {{$t('Phone')}}&nbsp;<span v-if="isRequiredField('phone')">*</span>
                      </label>
                      <div class="row">
                        <div class="col-3 pr-1">
                          <b-form-select v-model="user.phone_calling_code"
                                         :disabled="!isProfileEditEnabled"
                                         :options="callingCodeOptions"
                                         class="form-control m-input"
                          ></b-form-select>
                        </div>
                        <div class="col-9 pl-1">
                          <b-form-input id="phone"
                                        maxlength="12"
                                        type="tel"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        autocomplete="tel-national"
                                        :disabled="!isProfileEditEnabled"
                                        :required="isRequiredField('phone')"
                                        v-model="user.phone_local"
                                        :placeholder="$t('Enter the phone number without the country code')"
                                        @paste.native="handlePhonePaste"
                                        @keydown.native="onlyNumber"
                                        @input="user.phone_local = user.phone_local.replace(/\D/g, '')"
                          ></b-form-input>
                        </div>
                      </div>
                      <b-form-text v-if="errors.phone" class="text-danger text-justify">
                        {{ errors.phone }}
                      </b-form-text>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('phone')">
                        {{ fieldsDescription.phone }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-for="field in additionalFields" :key="field.key" class="form-group m-form__group row">
                      <div class="col-12 col-md-7">
                        <label :for="field.key"
                               class="form-label"
                               :class="labelClass(field.key)">
                          {{ field.name }}&nbsp;<span v-if="isRequiredField(field.key)">*</span>
                        </label>
                        <b-form-input :id="field.key"
                                      type="text"
                                      v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_TEXT"
                                      :disabled="!isProfileEditEnabled"
                                      :required="isRequiredField(field.key)"
                                      v-model="user[field.key]"></b-form-input>

                        <tags-input v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_TAGS"
                                    :disabled="!isProfileEditEnabled"
                                    :field-key="field.key"
                                    @initialized="initializeTags"
                                    v-model="arrays[field.key]"/>

                        <div v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_SWITCH" class="d-flex align-items-center ml-1">
                          <switches :disabled="!isProfileEditEnabled"
                                    class="form-switch"
                                    :color="user[field.key] ? 'green' : 'default'"
                                    v-model="user[field.key]"></switches>
                          <label :for="field.key" class="m-0 mt-1 ml-4 p-0">
                            {{ user[field.key] ? $t('Yes') : $t('No') }}
                          </label>
                        </div>

                        <number-spinner v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_COUNTER"
                                        :disabled="!isProfileEditEnabled"
                                        v-model="user[field.key]"
                                        @valid="state[field.key] = null"
                                        @invalid="state[field.key] = false"
                                        :min=-1000000000
                        />

                        <radio-select-input v-if="isRadioPresentationOfSelectFieldType(field)"
                                            :description="fieldsDescription[field.key]"
                                            :disabled="!isProfileEditEnabled"
                                            :field-key="field.key"
                                            :field-columns="typeof(field.json.mk) !== 'undefined' && typeof(field.json.mk.columns) !== 'undefined'? field.json.mk.columns : 3"
                                            :options="field.json.options"
                                            v-model="user[field.key]"/>

                        <b-form-select
                                      v-if="isSelectPresentationOfSelectFieldType(field)"
                                      :description="fieldsDescription[field.key]"
                                      :disabled="!isProfileEditEnabled"
                                      :field-key="field.key"
                                      :options="addChooseOption(field.json.options)"
                                      v-model="user[field.key]"
                        ></b-form-select>

                        <multi-select-input v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT"
                                            :disabled="!isProfileEditEnabled"
                                            :description="fieldsDescription[field.key]"
                                            :limits="getLimits(field)"
                                            :field-key="field.key"
                                            :valid-on-empty="!isRequiredField(field.key)"
                                            :options="field.json.options"
                                            :field-columns="typeof(field.json.mk) !== 'undefined' && typeof(field.json.mk.columns) !== 'undefined'? field.json.mk.columns : 3"
                                            @valid="state[field.key] = null"
                                            @invalid="state[field.key] = false"
                                            v-model="arrays[field.key]"/>

                        <b-form-text v-if="showFieldDescription(field)" class="text-muted text-justify" >
                          {{ fieldsDescription[field.key] }}
                        </b-form-text>
                      </div>
                    </div>

                </div>
                <div v-if="requiredFields.length"
                     class="m-form__seperator m-form__seperator--dashed m-form__seperator--space"></div>
                <div v-if="requiredFields.length" class="required-field-container">
                  {{$t('* - Required field')}}
                </div>
                <div v-if="isProfileEditEnabled" class="m-portlet__foot m-portlet__foot--fit">
                  <div class="m-form__actions">
                    <div class="row">
                      <div class="col-12">
                        <button href="#up" type="button" class="btn btn-ls m-btn m-btn--air"
                                :disabled="isSaving || isDeleting"
                                @click="updateUser">
                          {{$t('Save changes')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isSelfRegistered" class="m-portlet m-portlet--full-height">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  {{$t('Delete Account')}}
                </h3>
              </div>
            </div>
            <div class="m-portlet__head-tools">
            </div>
          </div>
          <div class="tab-content">
            <div class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body">
                <div class="row padding-0-30">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <div>
                      {{$t('Deleting account is permanent')}}
                    </div>
                    <button type="button" class="btn btn-default" v-b-modal.passwordPrompt
                            :disabled="isSaving || isDeleting">
                      {{$t('Delete Account')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <delete-account-password-prompt-modal :disabled="isSaving"
                                               @processing="isDeleting = $event"></delete-account-password-prompt-modal>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapActions, mapGetters, mapState} from 'vuex'
import moment from 'moment'
import Page from "./Page";
import DeleteAccountPasswordPromptModal from "../modal/DeleteAccountPasswordPromptModal";
import {
  ADDITIONAL_FIELD_TYPE_COUNTER,
  ADDITIONAL_FIELD_TYPE_MULTISELECT,
  ADDITIONAL_FIELD_TYPE_SELECT,
  ADDITIONAL_FIELD_TYPE_SWITCH,
  ADDITIONAL_FIELD_TYPE_TAGS,
  ADDITIONAL_FIELD_TYPE_TEXT,
  ADDITIONAL_FIELD_SELECT_PRESENTATION,
} from "@/utils/AdditionalFieldsTypes";
import { formatPostcode, isValidNamePart, isValidPostcode } from "@/utils/standardFieldValidation";
import Switches from "vue-switches";
import {chunkArray} from "@/utils/ChunkArray";
import NumberSpinner from "@/components/input/NumberSpinner";
import RadioSelectInput from "@/components/input/RadioSelectInput";
import MultiSelectInput from "@/components/input/MultiSelectInput";
import TagsInput from "@/components/input/TagsInput";
import CalendarLocaleMixin from "@/mixins/CalendarLocaleMixin";

const get = require('lodash.get');

  export default {
    name: "ProfilePage",
    mixins: [CalendarLocaleMixin],
    components: {
      MultiSelectInput,
      RadioSelectInput,
      NumberSpinner,
      Switches,
      DeleteAccountPasswordPromptModal,
      Page,
      DatePicker,
      TagsInput,
    },
    data() {
      return {
        ADDITIONAL_FIELD_TYPE_TEXT: ADDITIONAL_FIELD_TYPE_TEXT,
        ADDITIONAL_FIELD_TYPE_TAGS: ADDITIONAL_FIELD_TYPE_TAGS,
        ADDITIONAL_FIELD_TYPE_SWITCH: ADDITIONAL_FIELD_TYPE_SWITCH,
        ADDITIONAL_FIELD_TYPE_COUNTER: ADDITIONAL_FIELD_TYPE_COUNTER,
        ADDITIONAL_FIELD_TYPE_SELECT: ADDITIONAL_FIELD_TYPE_SELECT,
        ADDITIONAL_FIELD_TYPE_MULTISELECT: ADDITIONAL_FIELD_TYPE_MULTISELECT,
        ADDITIONAL_FIELD_SELECT_PRESENTATION: ADDITIONAL_FIELD_SELECT_PRESENTATION,
        enabled: true,
        isSaving: false,
        isDeleting: false,
        password: '',
        passwordError: '',
        user: {
          id: '',
          card_number: '',
          name: '',
          surname: '',
          company: '',
          nip: '',
          address: '',
          postcode: '',
          city: '',
          voivodeship: null,
          phone: '',
          phone_calling_code: null,
          phone_local: '',
          email: '',
          saldo: '',
          birthday: '',
          sex: '',
          additional_field_1: '',
          additional_field_2: '',
          additional_field_3: '',
          additional_field_4: '',
          additional_field_5: '',
          additional_field_6: '',
          additional_field_7: '',
          additional_field_8: '',
          additional_field_9: '',
          additional_field_10: '',
        },
        arrays: {
          additional_field_1: [],
          additional_field_2: [],
          additional_field_3: [],
          additional_field_4: [],
          additional_field_5: [],
          additional_field_6: [],
          additional_field_7: [],
          additional_field_8: [],
          additional_field_9: [],
          additional_field_10: [],
        },
        setState: false, //disable setting state before cloning
        state: {
          name: null,
          surname: null,
          company: null,
          nip: null,
          address: null,
          postcode: null,
          city: null,
          voivodeship: null,
          phone: null,
          email: null,
          saldo: null,
          birthday: null,
          sex: null,
          additional_field_1: null,
          additional_field_2: null,
          additional_field_3: null,
          additional_field_4: null,
          additional_field_5: null,
          additional_field_6: null,
          additional_field_7: null,
          additional_field_8: null,
          additional_field_9: null,
          additional_field_10: null,
        },
        voivodeships: [
          //placeholder = nazwa pola (PL "Województwo"), nie generyczne "Select" (LSD-526)
          {value: null, text: this.$t('State/Region')},
          {value: '0', text: 'Dolnośląskie'},
          {value: '1', text: 'Kujawsko-pomorskie'},
          {value: '2', text: 'Lubelskie'},
          {value: '3', text: 'Lubuskie'},
          {value: '4', text: 'Łódzkie'},
          {value: '5', text: 'Małopolskie'},
          {value: '6', text: 'Mazowieckie'},
          {value: '7', text: 'Opolskie'},
          {value: '8', text: 'Podkarpackie'},
          {value: '9', text: 'Podlaskie'},
          {value: '10', text: 'Pomorskie'},
          {value: '11', text: 'Śląskie'},
          {value: '12', text: 'Świętokrzyskie'},
          {value: '13', text: 'Warmińsko-mazurskie'},
          {value: '14', text: 'Wielkopolskie'},
          {value: '15', text: 'Zachodniopomorskie'},
        ],
        fieldStates: {
          phone: null,
        },
        errors: {
          phone: null,
          name: null,
          surname: null,
          postcode: null,
          email: null,
          address: null,
          city: null,
          company: null,
          nip: null,
          birthday: null,
          sex: null,
          voivodeship: null,
        },
      }
    },
    mounted() {
      this.fetchSettings(this.entityUuid);

      //fill form immediately
      this.cloneUserFormState();

      //update form after fetch
      this.fetchUser()
        .then(() => this.cloneUserFormState())
        .then(() => this.setState = true) //unlock state setting in watchers
        .then(() => this.initializeTags())
        .then(() => this.initializeMultiSelects())
        .then(() => this.initializeSwitches())
    },
    methods: {
      ...mapActions([
        'setUser',
        'fetchUser',
        'logout',
        'setLoginInfo',
        'fetchSettings',
        'pushToFirstPage',
        'fetchAccountItems',
      ]),
      formatPostcode(value) {
        //wspólna reguła (LSD-526); formatter odpala tylko przy wpisywaniu,
        //więc nie nadpisuje starych danych przy ładowaniu
        return formatPostcode(value);
      },
      cloneUserFormState() {
        //phone_local i phone_calling_code nie przychodzą z API - muszą istnieć na obiekcie
        //w momencie przypisania do this.user, inaczej Vue nie zrobi ich reaktywnymi
        //i watchery walidacji telefonu nie będą odpalać
        this.user = Object.assign(
          {phone_calling_code: null, phone_local: ''},
          JSON.parse(JSON.stringify(this.stateUser))
        );
        this.parsePhone();
      },
      parsePhone() {
        const phone = this.user.phone || '';
        const defaultCallingCode = this.defaultCallingCode;

        if (phone.startsWith('+') || phone.startsWith('00')) {
          let normalizedPhone = phone;
          if (phone.startsWith('00')) {
            normalizedPhone = '+' + phone.substring(2);
          }

          const codes = Object.keys(this.callingCodes).sort((a, b) => b.length - a.length);
          let found = false;
          for (const code of codes) {
            if (normalizedPhone.startsWith(code)) {
              this.user.phone_calling_code = code;
              this.user.phone_local = normalizedPhone.substring(code.length);
              found = true;
              break;
            }
          }
          if (!found) {
            this.user.phone_calling_code = defaultCallingCode;
            this.user.phone_local = phone;
          }
        } else {
          this.user.phone_calling_code = defaultCallingCode;
          this.user.phone_local = phone;
        }
      },
      onlyNumber(event) {
        // Pozwalaj na klawisze sterujące
        const isControlKey = [
          'Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight',
          'ArrowUp', 'ArrowDown', 'Delete', 'Home', 'End'
        ].includes(event.key);

        // Pozwalaj na kombinacje z Ctrl/Cmd (np. Ctrl+C, Ctrl+V, Ctrl+A)
        const isCombinedKey = event.ctrlKey || event.metaKey;

        // Pozwalaj tylko na cyfry
        const isDigit = /^\d$/.test(event.key);

        if (!isDigit && !isControlKey && !isCombinedKey) {
          event.preventDefault();
          return false;
        }
        return true;
      },
      handlePhonePaste(e) {
        const pastedData = e.clipboardData.getData('text');
        const cleanedData = pastedData.replace(/[\s()-]/g, '');

        if (cleanedData.startsWith('+') || cleanedData.startsWith('00')) {
          let searchData = cleanedData.startsWith('00') ? '+' + cleanedData.substring(2) : cleanedData;

          const options = Object.keys(this.callingCodes).sort((a, b) => b.length - a.length);
          let prefix = '';
          let local = '';

          for (const code of options) {
            if (searchData.indexOf(code) === 0) {
              prefix = code;
              local = searchData.substring(code.length);
              break;
            }
          }

          if (prefix) {
            this.user.phone_calling_code = prefix;
            setTimeout(() => {
              this.user.phone_local = local;
            }, 0);
            e.preventDefault();
          }
        }
      },
      cloneAgreementsFormState() {
        this.agreements = JSON.parse(JSON.stringify(this.stateAgreements))
      },
      addChooseOption(options) {
        let chooseOptions = [
            {value: null, text: this.$t('Choose')}
        ];
        for (const option in options) {
          chooseOptions.push({value: options[option], text: options[option]})
        }
        return chooseOptions;
      },
      validateRequiredFields() {
        if (this.user.phone_local && (this.user.phone_local.startsWith('+') || this.user.phone_local.startsWith('00'))) {
          this.fieldStates.phone = false
          this.errors.phone = this.$t('Don’t include the country code. Choose it from the list.')
        }

        this.requiredFields.forEach((key) => {
          const field = this.getField(key);

          if (this.user.hasOwnProperty(key)
            && typeof this.user[key] !== "boolean"
            && (this.user[key] === null || !this.user[key].toString().trim().length)
            && this.state.hasOwnProperty(key)
            && (!field || ![ADDITIONAL_FIELD_TYPE_MULTISELECT, ADDITIONAL_FIELD_TYPE_TAGS].includes(parseInt(field.type)))
          ) {
            this.state[key] = false
          }

          //tagi żyją w arrays[key] (user[key] to nieaktualny CSV z API) - generyczny
          //check na user[key] blokował submit mimo uzupełnionego pola
          if (field && parseInt(field.type) === ADDITIONAL_FIELD_TYPE_TAGS) {
            this.state[key] = (this.arrays[key] && this.arrays[key].length) ? null : false
          }

          if (field && parseInt(field.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT) {
            const limitsFrom = parseInt(get(field || {}, 'json.limits.from'));
            const count = this.arrays[key] ? this.arrays[key].length : 0;

            if (limitsFrom && limitsFrom > count) {
              this.state[key] = false
            } else if (count === 0) {
              this.state[key] = false
            }
          }
        });
      },
      updateUser() {
        if (this.isSaving || this.isDeleting) {
          return;
        }

        //telefon przeliczamy i walidujemy tylko gdy pole jest włączone w konfiguracji -
        //przy wyłączonym polu klient go nie widzi, a stary numer w bazie (sprzed reguły
        //LSD-525) nie może blokować zapisu pozostałych pól profilu
        if (this.isBaseFieldEnabled('phone')) {
          if (this.user.phone_local) {
            this.user.phone = (this.user.phone_calling_code || '') + this.user.phone_local.replace(/\D/g, '');
          } else {
            this.user.phone = '';
          }
        }

        this.validateRequiredFields();

        //walidujemy tylko pola włączone w konfiguracji, których wartość faktycznie
        //się zmienia - lustro reguł serwera (validateChanged): niewidoczne pole albo
        //nietknięta wartość legacy nie może blokować zapisu reszty profilu
        const isFieldValidatable = (field) =>
          this.isBaseFieldEnabled(field) && (this.user[field] || '') !== (this.stateUser[field] || '');

        if (this.isBaseFieldEnabled('phone')) {
          //walidacja synchroniczna - watcher user.phone odpala dopiero w nextTick,
          //więc bez tego pierwszy submit przechodzi mimo błędnego numeru
          this.setFieldState('phone', this.user.phone);

          if ((this.user.phone || '') !== (this.stateUser.phone || '')
            && !this.checkPattern('phone', this.user.phone)
          ) {
            this.errors.phone = this.$t('Enter a valid phone number.');
            this.$notify.warning(this.$t('Enter a valid phone number.'));
            return
          }
        }

        //wspólne reguły (LSD-526): min 2 znaki dla imienia/nazwiska, kod pocztowy 00-000
        //walidacja synchroniczna na submit - jak przy telefonie
        for (const key in this.errors) {
          if (key !== 'phone') {
            this.errors[key] = null;
          }
        }

        if (isFieldValidatable('name') && !isValidNamePart(this.user.name)) {
          this.errors.name = this.$t('Name contains minimun 2 chars');
        }

        if (isFieldValidatable('surname') && !isValidNamePart(this.user.surname)) {
          this.errors.surname = this.$t('Surname contains minimun 2 chars');
        }

        if (isFieldValidatable('postcode') && !isValidPostcode(this.user.postcode)) {
          this.errors.postcode = this.$t('Post code format 00-000');
        }

        if (this.errors.name || this.errors.surname || this.errors.postcode) {
          this.$notify.warning(this.errors.name || this.errors.surname || this.errors.postcode);
          return
        }

        let userToUpdate = JSON.parse(JSON.stringify(this.user));

        if (!this.user.phone_local || this.user.phone_local.length === 0) {
          if (userToUpdate.hasOwnProperty('phone_calling_code')) {
            delete userToUpdate.phone_calling_code;
          }
        }
        userToUpdate.phone = this.user.phone;

        let isSavingMissingFields = this.stateUser.missing_fields.length > 0;
        let isError = false;

        this.additionalFields.forEach((f) => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_TAGS) {
            userToUpdate[f.key] = this.arrays[f.key].map(o => o.value).join(',')
          }

          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT) {
            userToUpdate[f.key] = this.arrays[f.key].join('|')
          }

          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_SWITCH) {
            userToUpdate[f.key] = userToUpdate[f.key] ? 1 : 0
          }
        });

        for (let property in this.state) {
          const limitsFrom = parseInt(get(this.getField(property) || {}, 'json.limits.from'));

          if (this.state.hasOwnProperty(property) && this.state[property] === false
            && (!userToUpdate[property]
                  || !userToUpdate[property].length
                  || (limitsFrom && limitsFrom > userToUpdate[property].split('|').length))
          ) {
            isError = true;
            break;
          }
        }

        if (isError) {
          this.$notify.warning(this.$t('Fill all required fields'));
          return
        }

        if (!this.isFormValid) {
          this.$notify.warning(this.$t('Fill all required fields'));
          return
        }

        this.isSaving = true;
        return this.$http.patch('profile', userToUpdate)
          .then((r) => {
            if (r.data.success) {
              this.setUser(r.data.user)
                .then(() => this.cloneUserFormState())
                .then(() => this.initializeTags())
                .then(() => this.initializeMultiSelects())
                .then(() => this.initializeSwitches());
            } else {
              //serwerowa walidacja (LSD-526): pokaż błędy per pole i komunikat zbiorczy
              const serverErrors = r.data.errors || {};
              for (const field in serverErrors) {
                if (this.errors.hasOwnProperty(field)) {
                  this.errors[field] = serverErrors[field];
                }
              }
              if (r.data.message) {
                this.$notify.warning(r.data.message);
              }
            }

            if (isSavingMissingFields && this.stateUser.missing_fields.length === 0) {
              this.pushToFirstPage();
            }
          })
          .then(() => this.fetchAccountItems())
          .catch(() => {
            // HTTP errors, including logout on 401, are handled by the interceptor.
          })
          .finally(() => {
            this.isSaving = false;
          });
      },
      isRequiredField(field) {
        if (field === 'email') {
          return true;
        }

        return this.requiredFields.indexOf(field) !== -1
      },
      isNumeric: function (val) {
        return /^\d*$/.test(val);
      },
      checkPattern(field, value) {
        if (field === 'phone' && value !== '' && value !== null) {
          const callingCode = this.user.phone_calling_code || '';
          if (value === callingCode) {
            return true;
          }
          //wspólna reguła (LSD-525): część lokalna 6-12 cyfr, całość ≤15 cyfr bez znaku +
          const localDigits = (this.user.phone_local || '').replace(/\D/g, '');
          const totalDigits = value.replace(/\D/g, '');
          return /^[0-9]{6,12}$/.test(localDigits) && totalDigits.length <= 15;
        }
        return true;
      },
      getLimits(field) {
        return field.json.limits || {}
      },
      setFieldState(field, newValue) {
        if (!this.setState) {
          return;
        }

        const limitsFrom = parseInt(get(this.getField(field) || {}, 'json.limits.from'));
        const limitsTo = parseInt(get(this.getField(field) || {}, 'json.limits.to'));

        if (limitsFrom && limitsFrom > 0 && Array.isArray(newValue) && newValue.length < limitsFrom) {
          this.state[field] = false
        } else if (limitsTo && limitsTo > 0 && Array.isArray(newValue) && newValue.length > limitsTo) {
          this.state[field] = false
        } else if (!this.checkPattern(field,newValue)) {
          this.state[field] = false
        } else if (newValue && newValue.length) {
          this.state[field] = true
        } else if(typeof newValue === "number" && (newValue < 0 || newValue > 1000000000)) {
          this.state[field] = false
        } else if(typeof newValue === "number" && (newValue >= 0 || newValue <= 1000000000)) {
          this.state[field] = null
        } else if (typeof newValue === "boolean") {
          //switch w mk1 zawsze ma wartość (domyślnie "Nie") — false to poprawna
          //odpowiedź, nie brak wartości; bez tego wymagany switch świecił błędem
          this.state[field] = null
        } else if (this.isRequiredField(field)) {
          this.state[field] = false
        } else {
          this.state[field] = null
        }
      },
      initializeTags() {
        this.additionalFields.forEach(f => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_TAGS && this.user[f.key]) {
            this.arrays[f.key] = this.user[f.key].split(',').map(v => ({key: v, value: v}))
          }
        });
      },
      initializeMultiSelects() {
        this.additionalFields.forEach(f => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT && this.user[f.key]) {
            this.arrays[f.key] = this.user[f.key].split('|');
          }
        });
      },
      initializeSwitches() {
        this.additionalFields.forEach(f => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_SWITCH && this.user.hasOwnProperty(f.key)) {
            this.user[f.key] = parseInt(this.user[f.key] || 0) !== 0
          }
        });
      },
      isBaseFieldEnabled(field) {
        if (field === 'email') {
          return true;
        }

        if (!this.fieldsEnabled.hasOwnProperty(field)) {
          return false;
        }

        return this.fieldsEnabled[field];
      },
      chunkOptions(options, chunkSize = 2) {
        return chunkArray(options, chunkSize);
      },

      isSelectPresentationOfSelectFieldType(field) {
      return parseInt(field.type) === ADDITIONAL_FIELD_TYPE_SELECT && (typeof (field.json.mk) !== 'undefined' && field.json.mk.presentation === ADDITIONAL_FIELD_SELECT_PRESENTATION);
    },
      isRadioPresentationOfSelectFieldType(field) {
      return parseInt(field.type) === ADDITIONAL_FIELD_TYPE_SELECT && (typeof(field.json.mk) === 'undefined' || field.json.mk.presentation!==ADDITIONAL_FIELD_SELECT_PRESENTATION);
    },

      showFieldDescription(field) {
        const fieldsWithoutRegularDescription = [
            ADDITIONAL_FIELD_TYPE_SELECT,
            ADDITIONAL_FIELD_TYPE_MULTISELECT,
        ];

        if(this.isSelectPresentationOfSelectFieldType(field) && this.fieldsDescription.hasOwnProperty(field.key)){
          return true;
        }

        return fieldsWithoutRegularDescription.indexOf(parseInt(field.type)) === -1
            && this.fieldsDescription.hasOwnProperty(field.key);
      },
      labelClass(fieldKey) {
        return this.state[fieldKey] === false ? 'has-error' : '';
      }
    },
    computed: {
      ...mapState({
        stateUser: state => state.auth.user,
        entityUuid: state => state.auth.entity.uuid,
        missingFields: state => state.auth.user.missing_fields,
        disableProfileEdit: state => state.settings.disableProfileEdit,
        isSelfRegistered: state => state.auth.user.self_registered,
        requiredFields: state => state.settings.requiredFields,
        additionalFields: state => state.settings.additionalFields,
        fieldsDescription: state => state.settings.profile.fieldsDescription,
        fieldsEnabled: state => state.settings.profile.fieldsEnabled,
        callingCodes: state => state.settings.callingCodes,
        defaultCallingCode: state => state.settings.defaultCallingCode,
        stateEntity: state => state.settings.entity,
      }),
      ...mapGetters([
          'getField',
      ]),
      isProfileEditEnabled() {
        if (this.missingFields.length > 0) {
          return true;
        }

        return this.disableProfileEdit === '0'
      },
      isFormValid() {
        if (this.state) {
          for (const [, value] of Object.entries(this.state)) {
            if (value === false) {
              return false;
            }
          }
        }

        if (this.fieldStates) {
          for (const [, value] of Object.entries(this.fieldStates)) {
            if (value === false) {
              return false;
            }
          }
        }

        return true;
      },
      callingCodeOptions() {
        const options = [
          {value: null, text: this.$t('Select') + '...'}
        ];
        for (const code in this.callingCodes) {
          options.push({
            value: code,
            text: this.callingCodes[code]
          });
        }
        return options;
      }
    },
    watch: {
      defaultCallingCode(newValue) {
        if (newValue && !this.user.phone_calling_code) {
          this.user.phone_calling_code = newValue;
        }
      },
      'user.birthday'(newValue) {
        this.user.birthday = (newValue)
          ? moment(newValue).format('YYYY-MM-DD')
          : '';

        this.setFieldState('birthday', newValue)
      },
      'user.name'(newValue) {
        this.setFieldState('name', newValue)
      },
      'user.surname'(newValue) {
        this.setFieldState('surname', newValue)
      },
      'user.company'(newValue) {
        this.setFieldState('company', newValue)
      },
      'user.nip'(newValue) {
        this.setFieldState('nip', newValue)
      },
      'user.address'(newValue) {
        this.setFieldState('address', newValue)
      },
      'user.postcode'(newValue) {
        this.setFieldState('postcode', newValue)
      },
      'user.phone_local'(newValue) {
        if (newValue) {
          const cleaned = newValue.replace(/\D/g, '');
          if (cleaned !== newValue) {
            this.user.phone_local = cleaned;
          }
        }
        this.user.phone = (this.user.phone_calling_code || '') + (this.user.phone_local || '').replace(/\D/g, '');
        if (newValue && (newValue.startsWith('+') || newValue.startsWith('00'))) {
          this.fieldStates.phone = false
          this.errors.phone = this.$t('Don’t include the country code. Choose it from the list.')
        } else if (this.errors.phone === this.$t('Don’t include the country code. Choose it from the list.')) {
          this.fieldStates.phone = null
          this.errors.phone = null
        }
      },
      'user.phone_calling_code'(newValue) {
        this.user.phone = (newValue || '') + this.user.phone_local.replace(/\D/g, '');
      },
      'user.city'(newValue) {
        this.setFieldState('city', newValue)
      },
      'user.voivodeship'(newValue) {
        this.setFieldState('voivodeship', newValue)
      },
      'user.phone'(newValue) {
        this.setFieldState('phone', newValue)

        if (!this.setState) {
          return;
        }

        if (!this.checkPattern('phone', newValue)) {
          this.errors.phone = this.$t('Enter a valid phone number.');
        } else if (this.errors.phone === this.$t('Enter a valid phone number.')) {
          this.errors.phone = null;
        }
      },
      'user.email'(newValue) {
        this.setFieldState('email', newValue)
      },
      'user.saldo'(newValue) {
        this.setFieldState('saldo', newValue)
      },
      'user.sex'(newValue) {
        this.setFieldState('sex', newValue)
      },
      'user.additional_field_1'(newValue) {
        this.setFieldState('additional_field_1', newValue)
      },
      'user.additional_field_2'(newValue) {
        this.setFieldState('additional_field_2', newValue)
      },
      'user.additional_field_3'(newValue) {
        this.setFieldState('additional_field_3', newValue)
      },
      'user.additional_field_4'(newValue) {
        this.setFieldState('additional_field_4', newValue)
      },
      'user.additional_field_5'(newValue) {
        this.setFieldState('additional_field_5', newValue)
      },
      'user.additional_field_6'(newValue) {
        this.setFieldState('additional_field_6', newValue)
      },
      'user.additional_field_7'(newValue) {
        this.setFieldState('additional_field_7', newValue)
      },
      'user.additional_field_8'(newValue) {
        this.setFieldState('additional_field_8', newValue)
      },
      'user.additional_field_9'(newValue) {
        this.setFieldState('additional_field_9', newValue)
      },
      'user.additional_field_10'(newValue) {
        this.setFieldState('additional_field_10', newValue)
      }
    },
  }
</script>

<style>
  .label-switch {
    text-align: right;
  }

  .padding-0-30 {
    padding: 0 30px;
  }

  .required-field-container {
    padding-left: 30px;
    padding-bottom: 20px;
  }
</style>
<style scoped>
#up >>> .mx-datepicker-popup {
  right: auto !important;
}

#up >>> .mx-datepicker {
  display: flex;
  flex-grow: 1;
}

#up >>> .mx-input-wrapper {
  display: flex;
  flex-grow: 1;
}

#up >>> .label-switch input[type=checkbox] {
  display: none;
}

#up >>> .form-switch {
  margin-top: 12px
}

#up >>> .m-form__group {
  padding-top: 0 !important;
  padding-bottom: 20px !important;
}


#up >>> .form-label {
  font-weight: 600 !important;
}

#up >>> .m-form__group:last-of-type {
  padding-bottom: 10px !important;
}

#up >>> .form-label.has-error {
  color: red;
}
</style>
